<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Booking Bank</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="form"
      dataName="form"
      (updateFields_child)="updateFields($event)"
    />
    <div class="mb-2 flex w-fit gap-1">
      <button class="shorter-btn show-btn" (click)="printStatus()">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Export
      </button>
    </div>
  </div>
</section>
